import { render, staticRenderFns } from "./DescuentosAbonados.vue?vue&type=template&id=24c094d2"
import script from "./DescuentosAbonados.vue?vue&type=script&setup=true&lang=js"
export * from "./DescuentosAbonados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports